var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#777E91"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.717 13.553c.612.606 1.283 1.531 1.283 2.683V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-.764c0-1.152.671-2.077 1.283-2.683C1.678 13.16 2 12.647 2 12c0-.647-.322-1.16-.717-1.553C.67 9.841 0 8.916 0 7.764V7a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v.764c0 1.152-.671 2.077-1.283 2.683-.395.392-.717.906-.717 1.553 0 .647.322 1.16.717 1.553ZM22 16.236c0-.363-.227-.803-.69-1.263C20.695 14.365 20 13.371 20 12c0-1.37.696-2.365 1.31-2.973.463-.46.69-.9.69-1.263V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v.764c0 .363.227.802.69 1.263C3.305 9.635 4 10.629 4 12c0 1.37-.696 2.365-1.31 2.973-.463.46-.69.9-.69 1.263V17a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-.764Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.707 10.707-4 4a1 1 0 0 1-1.414-1.414l4-4a1 1 0 1 1 1.414 1.414ZM11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM13 14a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLine;